/* ------------------------------------------------------------------ */
/* Helpers de cardinalidad / coerción para filas de Supabase, que       */
/* devuelve relaciones to-many como objeto o array según el select.     */
/* Viven en `shared` para que dominio (p. ej. la financiación de una    */
/* orden) no dependa de utilidades de presentación.                    */
/* ------------------------------------------------------------------ */

export function asArray<T>(value: T | T[] | null | undefined): T[] {
  if (value == null) return [];
  return Array.isArray(value) ? value : [value];
}

export function pickOne<T>(value: T | T[] | null | undefined): T | undefined {
  if (value == null) return undefined;
  return Array.isArray(value) ? value[0] : value;
}

export function asNumber(value: unknown): number | null {
  if (value == null) return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}
